(function () {
  function initCameliaStory(root) {
    if (!root || root.dataset.cameliaInit === 'true') return;
    root.dataset.cameliaInit = 'true';

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var staticWrap = root.querySelector('[data-camelia-static]');

    if (reducedMotion) {
      if (staticWrap) staticWrap.hidden = false;
      var track = root.querySelector('[data-camelia-track]');
      if (track) track.style.display = 'none';

      var staticTabs = root.querySelectorAll('[data-camelia-static-nav]');
      staticTabs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-camelia-static-nav');
          staticTabs.forEach(function (b) {
            var active = b === btn;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          root.querySelectorAll('.camelia-story__static-panel').forEach(function (panel) {
            var match = panel.id === 'camelia-static-panel-' + root.getAttribute('data-section-id') + '-' + target;
            panel.hidden = !match;
            panel.classList.toggle('is-active', match);
          });
        });
      });
      return;
    }

    var zones = Array.prototype.slice.call(root.querySelectorAll('[data-camelia-zone]'));
    var navButtons = Array.prototype.slice.call(root.querySelectorAll('[data-camelia-nav]'));
    var visualPanels = Array.prototype.slice.call(root.querySelectorAll('[data-camelia-panel]'));
    var copyPanels = Array.prototype.slice.call(root.querySelectorAll('[data-camelia-panel-copy]'));

    function setActive(step) {
      navButtons.forEach(function (btn) {
        var idx = parseInt(btn.getAttribute('data-camelia-nav'), 10);
        btn.classList.toggle('is-active', idx === step);
        btn.classList.toggle('is-complete', idx < step);
      });
      visualPanels.forEach(function (panel) {
        panel.classList.toggle('is-active', parseInt(panel.getAttribute('data-camelia-panel'), 10) === step);
      });
      copyPanels.forEach(function (panel) {
        panel.classList.toggle('is-active', parseInt(panel.getAttribute('data-camelia-panel-copy'), 10) === step);
      });
    }

    function computeActiveStep() {
      var center = window.innerHeight / 2;
      var step = 1;
      for (var i = 0; i < zones.length; i++) {
        var rect = zones[i].getBoundingClientRect();
        if (rect.top <= center && rect.bottom >= center) {
          step = i + 1;
          break;
        }
        if (rect.top < center) {
          step = i + 1;
        }
      }
      return step;
    }

    if (zones.length && 'IntersectionObserver' in window) {
      var ticking = false;
      var zoneObserver = new IntersectionObserver(function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          setActive(computeActiveStep());
          ticking = false;
        });
      }, { threshold: 0, rootMargin: '-50% 0px -50% 0px' });
      zones.forEach(function (zone) { zoneObserver.observe(zone); });
    }

    navButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-camelia-nav'), 10);
        var zone = zones[step - 1];
        if (zone) {
          zone.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        setActive(step);
      });
    });
  }

  function initAll(rootDoc) {
    rootDoc.querySelectorAll('[data-camelia-education-story]').forEach(initCameliaStory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
